/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Mon May 09 2022
*  File : fanpage-server-sdk-dev.ts
*******************************************/

import { SdkServer } from "../../../../cookist/com/lib/modules/SdkServer.js";
import { config } from "../../../../cookist/com/lib/config/production.js";

window['ServerSdk'] = SdkServer(config);
window['ServerSdk'].init();